import request from '../api/request'

function get(id) {
    return request({
        url: `/tickets/${id}.json`,
        method: 'GET'
    });
}

function index() {
    return request({
        url: `/ticket_type.json`,
        method: 'GET'
    });
}

function update(id, studentId, data) {
    return request({
        url: `/students/${studentId}/tickets/${id}.json`,
        method: 'PUT',
        data: data
    });
}

function create(studentId, data) {
    return request({
        url: `/students/${studentId}/tickets.json`,
        method: 'POST',
        data: data
    });
}

function createInClass(studentId, yclassId, data) {
    return request({
        url: `/students/${studentId}/tickets/new_ticket_in_class.json?class_id=${yclassId}`,
        method: 'POST',
        data: data
    });
}

function deleteTicket(studentId, id) {
    return request({
        url: `/students/${studentId}/tickets/${id}.json`,
        method: 'DELETE'
    });
}

function ticketReport(data) {
    return request({
        url: `/users/-1/ticket_report.json${data}`,
        method: 'GET',
    });
}

function expiringTicketReport() {
    return request({
        url: `/users/-1/ticket_report.json?expiring=true`,
        method: 'GET',
    });
}

function renewableTicketReport() {
    return request({
        url: `/users/-1/renewable_tickets.json`,
        method: 'GET',
    });
}

const TicketApiService = {
    index, get, create, update, deleteTicket, createInClass, ticketReport, expiringTicketReport, renewableTicketReport
};

export default TicketApiService;